export const fonts = {
    heading: `Archivo`,
    body: `Plus Jakarta Sans`,
    mono: `Courier New, monospace`,
};

export default fonts;
